import { render, staticRenderFns } from "./PartnerComponent.vue?vue&type=template&id=6792556e&scoped=true"
import script from "./PartnerComponent.vue?vue&type=script&lang=js"
export * from "./PartnerComponent.vue?vue&type=script&lang=js"
import style0 from "./PartnerComponent.vue?vue&type=style&index=0&id=6792556e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6792556e",
  null
  
)

export default component.exports